import Table, { TableProps } from "@/shared/data-display/table";
import { useTranslations } from "use-intl";
import { BpmRolesListRecordFragment } from "gql/graphql";
import {
  BpmRolesListColumns,
  titles,
} from "@/modules/bpm/widgets/bpm-roles-list/ui/bpm-roles-list-columns";
import { FC } from "react";
import { BpmRolesListItemOptionsProps } from "@/modules/bpm/widgets/bpm-roles-list-item-options";

export function BpmRolesListView({
  setEditId,
  Options,
  ...props
}: TableProps<BpmRolesListRecordFragment> & {
  setEditId: (id: string | null) => void;
  Options: FC<BpmRolesListItemOptionsProps>;
}) {
  const t = useTranslations("BpmRolesList");

  return (
    <Table
      {...props}
      rowKey={(record) => record.id}
      columns={[
        {
          key: "person name",
          title: t(titles.person),
          responsive: ["sm"],
          render: (_, record) => (
            <BpmRolesListColumns.PersonName
              record={record}
              setEditId={setEditId}
            />
          ),
        },
        {
          key: "department",
          title: t(titles.department),
          responsive: ["sm"],
          render: (_, record) => (
            <BpmRolesListColumns.Department record={record} />
          ),
        },
        {
          key: "role",
          title: t(titles.role),
          responsive: ["sm"],
          render: (_, record) => <BpmRolesListColumns.Role record={record} />,
        },
        {
          key: "options",
          responsive: ["sm"],
          render: (_, record) => <Options bpmRoleId={record.id} />,
        },
        {
          key: "mobile",
          title: t(titles.bpmRolesList),
          responsive: ["xs"],
          render: (_, record) => (
            <BpmRolesListColumns.Mobile record={record} setEditId={setEditId} />
          ),
        },
      ]}
    />
  );
}
